export const getAuthRedirectUri = (auth: {
  redirectUri: string;
  oldRedirectUri?: string;
}): string =>
  auth.oldRedirectUri && window.location.hostname.endsWith('jobcloud.ai')
    ? auth.oldRedirectUri
    : auth.redirectUri;
